import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useMeteringRecords} from '../hooks/useMeteringRecords.ts';
import {useMeteringRecordsSelection} from "../hooks/useMeteringRecordsSelection.ts";

export const DeleteRecordButton = () => {

    const {deleteRecords} = useMeteringRecords();

    const {
        selection,
        handleClearSelection,
    } = useMeteringRecordsSelection();

    const recordIds = Object.keys(selection);
    let disabled = true;
    if (recordIds.length > 0) {
        disabled = false;
    }


    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={() => {
            deleteRecords()
            handleClearSelection()
        }}/>);
};
